var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10980_15749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 15.3332V12.6665H4.66797C4.3013 12.6665 3.98741 12.5359 3.7263 12.2748C3.46519 12.0137 3.33464 11.6998 3.33464 11.3332V4.6665H0.667969V3.33317H3.33464V0.666504H4.66797V11.3332H15.3346V12.6665H12.668V15.3332H11.3346ZM11.3346 9.99984V4.6665H6.0013V3.33317H11.3346C11.7013 3.33317 12.0152 3.46373 12.2763 3.72484C12.5374 3.98595 12.668 4.29984 12.668 4.6665V9.99984H11.3346Z",
    fill: "#5F6368"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10980_15749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.317c02e0b053a956013c43036792de96.svg";
export { ForwardRef as ReactComponent };